// extracted by mini-css-extract-plugin
module.exports = {"modal":"ConfirmModal_modal__l2VzB"};